import { checkAppointDataChange, checkNotReceiveDataChange } from '@/utils/public';
// 不上报的轮询接口
const excludeRoutes = [
  'business/proregister/getAvailableOrdersByPage',
  'business/socket/querySocketMessage'
]
export function trackerHandler(msg) {
  const { event, payload, result } = msg;
  let message = '', changes = {}, contentObj = null;
  // 通知埋点
  switch (event) {
    case 'request_start':
      message = '#API#-request'
      contentObj = {url: payload?.url, data: payload?.data || {}}
      break;
    case 'response_success':
      if(payload?.url === 'business/proregister/getAppointAndNotReceiveNum') {
        message = '#API#-待接诊数量-getAppointAndNotReceiveNum'
        changes = checkAppointDataChange(result?.data || {}, result?.logTraceId || '');
        if(changes) {
          contentObj = {url: payload?.url, changes: changes?.changes, currentData: result?.data, logTraceId: changes?.logTraceId}
          // console.log('worker track-event getAppointAndNotReceiveNum', contentObj);
        }
      } else if (payload?.url === 'business/proregister/getNotReceiveByDocPage'){
        message = '#API#-待接诊数量-getNotReceiveByDocPage'
        changes = checkNotReceiveDataChange({config: {_rawData: payload || {}}}, result?.data || {}, result?.logTraceId || '');
        if(changes) {
          contentObj = {url: payload?.url, changes: changes?.changes, serviceType: changes?.serviceType, currentData: result?.data, logTraceId: changes?.logTraceId}
          // console.log('worker track-event changes-getNotReceiveByDocPage', contentObj);
        }
      } else if (payload?.url === 'business/proregister/getAvailableOrdersByPage' && payload?.isGrabList) {
        message = '#NOTICE#消息提醒-抢单列表数量-getAvailableOrdersByPage'
        changes = checkNotReceiveDataChange({config: {_rawData: payload || {}}}, result?.data || {}, result?.logTraceId || '');
        if(changes) {
          contentObj = {url: payload?.url, changes: changes?.changes, serviceType: changes?.serviceType, currentData: result?.data, logTraceId: changes?.logTraceId}
          // console.log('worker track-event isGrabList', contentObj);
        }
      } else if (payload?.url === 'business/proCheckPrescription/getCheckPrescriptionStatusNum') {
        message = '#API#处方审核数量变化-getCheckPrescriptionStatusNum'
        changes = checkAppointDataChange(result?.data || {}, result?.logTraceId || '');
        if(changes) {
          contentObj = {url: payload?.url, changes: changes?.changes, serviceType: changes?.serviceType, currentData: result?.data, logTraceId: changes?.logTraceId}
          // console.log('worker track-event getCheckPrescriptionStatusNum', contentObj);
        }
      } else if (payload?.url === 'business/proCheckPrescription/getNotCheckPrescriptionList') {
        message = '#API#处方待审核列表数据变化-getNotCheckPrescriptionList'
        changes = checkNotReceiveDataChange({config: {_rawData: payload || {}}},result?.data || {}, result?.logTraceId || '');
        if(changes) {
          contentObj = {url: payload?.url, changes: changes?.changes, serviceType: changes?.serviceType, currentData: result?.data, logTraceId: changes?.logTraceId}
          // console.log('worker track-event getNotCheckPrescriptionList', contentObj);
        }
      } else {
        message = '#API#-response'
        contentObj = {url: payload?.url, responseData: result}
      }
      break;
    case 'response_error':
      console.log('worker track-event error', payload);
      break;
    default:
      break;
  }
  if(!excludeRoutes.includes(payload?.url) && message && contentObj) {
    window.$tracker.send({
      message,
      content: JSON.stringify(contentObj),
      docName: payload?.docName || ''
    });
  } 
}
